export const GET_DOCUMENT_MONTHLY_STATS = 'GET_DOCUMENT_MONTHLY_STATS'
export const GET_DOCUMENT_MONTHLY_STATS_FAILED = 'GET_DOCUMENT_MONTHLY_STATS_FAILED'
export const GET_DOCUMENT_MONTHLY_STATS_SUCCEEDED = 'GET_DOCUMENT_MONTHLY_STATS_SUCCEEDED'

export const GET_DOCUMENT_WEEKLY_STATS = 'GET_DOCUMENT_WEEKLY_STATS'
export const GET_DOCUMENT_WEEKLY_STATS_FAILED = 'GET_DOCUMENT_WEEKLY_STATS_FAILED'
export const GET_DOCUMENT_WEEKLY_STATS_SUCCEEDED = 'GET_DOCUMENT_WEEKLY_STATS_SUCCEEDED'
